import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subject, takeUntil } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { isReallyOnline } from './internet.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkPollingService implements OnDestroy {
  private readonly pollingInterval = 30000;
  private destroy$ = new Subject<void>();

  constructor() {
    interval(this.pollingInterval)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => isReallyOnline())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
